import  {Home}  from "../them";
import style from './header.css'
import { useRef,useEffect } from "react";

function Header () {
     const menuRef = useRef(null);
  const toggleRef = useRef(null);

  useEffect(() => {
    const toggle = toggleRef.current;
    const menu = menuRef.current;

    if (toggle && menu) {
      toggle.onclick = () => {
        toggle.classList.toggle('active');
        menu.classList.toggle('responsive');
      };
    }
  }, []);
    return (
        <div className="HeadStyle" style={style} id="header">
            <h1> Welcome to my portfolio </h1>
            <nav className="toggle" ref={toggleRef}></nav>
         <nav className="menu" ref={menuRef}>
            <a href='/'  className="Link"> home </a>
            <a href='/#skill'  className="Link"> Skills </a>
            <a href='/#portfolio'  className="Link"> Projets </a>
         </nav>
            <Home />
        </div>

    )
}

export default  Header;